import { Lightning } from '@lightningjs/sdk'
import { LinkModel } from '../../types/flo-experience'
import { Loader } from '../Loader/LoaderWrapper'

export class PaginateBlock extends Lightning.Component {
  private _data: LinkModel

  static _template() {
    return {
      w: (w) => w,
      h: (h) => h,
      Loader: {
        width: 52,
        height: 48,
        x: (w) => w / 2,
        y: (h) => h / 2,
        mount: 0.5,
        type: Loader,
        visible: false,
      },
    }
  }

  get loader() {
    return this.tag('Loader')
  }

  set data(v: LinkModel) {
    this._data = v
  }

  get data() {
    return this._data
  }

  get style() {
    return this._data?.style
  }

  get type() {
    return this._data?.type
  }

  get url() {
    return this._data?.url
  }

  toggleLoader(toggle: boolean) {
    this.loader.visible = toggle
  }
}
